import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@pella/sash-framework';

const BackBtn = ({ title, renderWrapperAs = 'li' }) => {
	const WrapperTag = renderWrapperAs;

	const onBackToMenuClick = (e) => {
		const menu = document.getElementById('js-mobileMenu');
		const parentList = e.currentTarget.parentNode.parentNode;
		const prevParent = parentList.parentNode.parentNode;
		parentList.classList.remove('!right-0');

		if (prevParent.parentNode === menu) {
			menu.classList.remove('overflow-hidden');
		}
	};

	return (
		<WrapperTag>
			<button
				onClick={onBackToMenuClick}
				className='pal-mobileNav-Btn relative block w-full border-b border-b-gray-20 bg-gray-5 px-4 py-3 text-center text-base font-semibold uppercase leading-tight text-black no-underline hover:text-blue focus:text-blue md:px-14'
				aria-label={title}
			>
				<Icon
					name='keyboard_arrow_left'
					className='absolute left-4 top-1/2 -translate-y-1/2'
					size={30}
				/>

				{title}
			</button>
		</WrapperTag>
	);
};

BackBtn.propTypes = {
	title: PropTypes.string,
	renderWrapperAs: PropTypes.string,
};

export default BackBtn;
